import React from 'react';

interface SystemMessageProps {
  text: string;
}

const SystemMessage: React.FC<SystemMessageProps> = ({ text }) => {
  return (
    <div className="flex items-center gap-2 py-2">
      <div className="flex-1 h-px bg-slate-200" />
      <span className="text-xs text-slate-400 whitespace-nowrap">{text}</span>
      <div className="flex-1 h-px bg-slate-200" />
    </div>
  );
};

export default SystemMessage;
